// extracted by mini-css-extract-plugin
export default {"item":"YH8zOM","fadeIn":"YMW3Is"};